import axios from "axios";
import { URI } from "../Constants/ApiConstants";
import { getApiServerProPath } from "../Helper/ReadWriteApiPath";

export const getSessionDetails = async (centerId, sessionId) => {
  const { data } = await axios.get(
    `${getApiServerProPath()}/${URI.Entity.Centers}/${centerId}/${URI.Entity.Sessions}/${sessionId}/${URI.Entity.Students}/${URI.Property.Pdf}`,
  );
  return data;
};

export const getStudentPdfResults = async (centerId, studentId, sessionId, params) => {
  console.log(`Student ${studentId} pdf info retrieved ✅`)
  const { data } = await axios.post(
    `${getApiServerProPath()}/${URI.Entity.Centers}/${centerId}/${URI.Entity.Sessions}/${sessionId}/${URI.Entity.Students}/${studentId}`,
    params
  );
  return data;
}